import { BrandLogoEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const brandLogoCreateSuccess = createAction(
  "[Brand Logo] Create Success",
  props<{ brandLogo: BrandLogoEntity }>()
);

export const brandLogoDeleteSuccess = createAction(
  "[Brand Logo] Delete Success",
  props<{ brandLogo: BrandLogoEntity }>()
);

export const brandLogoUseSuccess = createAction(
  "[Brand Logo] Use Success",
  props<{ brandLogo: BrandLogoEntity }>()
);

export const brandLogoUnUseSuccess = createAction(
  "[Brand Logo] Un Use Success",
  props<{ brandLogo: BrandLogoEntity }>()
);
